import React, { useEffect } from 'react'
import {Titulo} from 'asocomponents'
import Layout from '../layouts/Layout'
import { useNavigate } from 'react-router-dom'
import GrillaJuiciosContainer from '../../components/organismos/GrillaJuiciosContainer/GrillaJuiciosContainer'
import FiltrosJuiciosContainer from '../../components/organismos/FiltrosJuiciosContainer/FiltrosJuiciosContainer'

function GrillaJuicios() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <Titulo titulo="Bandeja de Juicios"/>
      <FiltrosJuiciosContainer />
      <GrillaJuiciosContainer />
    </Layout>
  )
}

export default GrillaJuicios